/* ===== Zevar Gallery — storefront JS ===== */
(function () {
  'use strict';

  var moneyFormat = (window.Shopify && Shopify.currency && Shopify.currency.active) ? null : null;

  function formatMoney(cents) {
    var amount = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var fmt = (window.ZEVAR && window.ZEVAR.moneyFormat) || '';
    if (fmt && /\{\{\s*amount/.test(fmt)) {
      return fmt.replace(/\{\{\s*amount(_no_decimals|_with_comma_separator)?\s*\}\}/g, amount);
    }
    var symbol = (window.ZEVAR && window.ZEVAR.currencySymbol) || '$';
    return symbol + amount;
  }

  /* ---------- Cart drawer open/close ---------- */
  function openCart() { document.body.classList.add('cart-open'); }
  function closeCart() { document.body.classList.remove('cart-open'); }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) {
      e.preventDefault(); closeCart(); return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  /* ---------- Render cart drawer ---------- */
  function renderCart(cart) {
    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var itemsWrap = drawer.querySelector('[data-cart-items]');
    var emptyWrap = drawer.querySelector('[data-cart-empty]');
    var footWrap = drawer.querySelector('[data-cart-foot]');
    var subEl = drawer.querySelector('[data-cart-subtotal]');
    var titleCount = drawer.querySelector('[data-cart-title-count]');
    if (titleCount) titleCount.textContent = cart.item_count;

    if (cart.item_count === 0) {
      if (emptyWrap) emptyWrap.classList.remove('hidden');
      if (footWrap) footWrap.classList.add('hidden');
      if (itemsWrap) itemsWrap.innerHTML = '';
      return;
    }

    if (emptyWrap) emptyWrap.classList.add('hidden');
    if (footWrap) footWrap.classList.remove('hidden');
    if (subEl) subEl.textContent = formatMoney(cart.total_price);

    var html = '';
    cart.items.forEach(function (item) {
      var img = item.image ? item.image.replace(/(\.[^.]+)(\?.*)?$/, '_160x$1$2') : '';
      html += '' +
        '<div class="cart-line" data-line-key="' + item.key + '">' +
          '<div class="thumb">' + (img ? '<img src="' + img + '" alt="' + escapeHtml(item.product_title) + '">' : '') + '</div>' +
          '<div class="info">' +
            '<div class="row">' +
              '<a class="name" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
              '<button class="remove" data-qty="0" aria-label="Remove">' + closeIcon() + '</button>' +
            '</div>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="unit">' + escapeHtml(item.variant_title) + '</div>' : '') +
            '<div class="unit">' + formatMoney(item.final_price) + '</div>' +
            '<div class="bottom">' +
              '<div class="qty">' +
                '<button data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">' + minusIcon() + '</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button data-qty="' + (item.quantity + 1) + '" aria-label="Increase">' + plusIcon() + '</button>' +
              '</div>' +
              '<div class="line-price">' + formatMoney(item.final_line_price) + '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
    });
    if (itemsWrap) itemsWrap.innerHTML = html;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function closeIcon() { return '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>'; }
  function minusIcon() { return '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="6" y1="12" x2="18" y2="12"/></svg>'; }
  function plusIcon() { return '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="12" y1="6" x2="12" y2="18"/><line x1="6" y1="12" x2="18" y2="12"/></svg>'; }

  /* ---------- Cart API helpers ---------- */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- Add to cart (AJAX) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        renderCart(cart);
        openCart();
      })
      .catch(function () { /* fall back silently */ })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = original; }
      });
  });

  /* ---------- Quantity & remove inside drawer ---------- */
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-qty]');
    if (!qtyBtn) return;
    var line = qtyBtn.closest('[data-line-key]');
    if (!line) return;
    e.preventDefault();
    var key = line.getAttribute('data-line-key');
    var qty = parseInt(qtyBtn.getAttribute('data-qty'), 10);
    changeLine(key, Math.max(0, qty)).then(renderCart);
  });

  /* ---------- PDP gallery ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-gallery-main]');
    if (main) main.src = thumb.getAttribute('data-full') || thumb.src;
  });

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    fetchCart().then(renderCart).catch(function () {});
  });
})();
